import { hasSlidingMesh } from './slidingOptions';

export const syncOperationDraft = (draft, live, key, values) => {
  if (!draft || draft.model_id !== live.model_id || draft.layout !== live.layout) return draft;
  if (key === 'screens' && !hasSlidingMesh(draft)) return draft;
  return { ...draft, [key]: { ...draft[key], ...values } };
};